import type { FilterFn } from "@tanstack/react-table";
import type { NumberRangeValue } from "@/components/ui/NumberRangeInput";

function isNumberRangeEmpty(value: unknown): boolean {
  const range = value as NumberRangeValue | undefined;
  return !range || (range.min === undefined && range.max === undefined);
}

// TanStack auto-infers `inNumberRange` for numeric columns with no explicit
// filterFn. Its `autoRemove` reads the filter value as a [min, max] tuple, so
// our `{min, max}` object always looks empty and gets silently dropped before
// it reaches columnFilters state. This stand-in fixes autoRemove; the actual
// filtering happens server-side (manualFiltering), so the row check is a no-op.
export function createNumberRangeFilterFn<TData>(): FilterFn<TData> {
  const filterFn: FilterFn<TData> = () => true;
  filterFn.autoRemove = isNumberRangeEmpty;
  return filterFn;
}
